import React, { useState, useEffect } from "react";
import "../Assets/styles/newStyles/DoctorDetails.css";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Info from "../Assets/images/info.png";
import profileIcon from "../Assets/images/profile-icon.svg";
import changeIcon from "../Assets/images/edit-2.svg";
import emailIcon from "../Assets/images/EnvelopeSimple.svg";
import phoneIcon from "../Assets/images/Phone.svg";
import axios from "../axios";
import { useParams } from "react-router-dom";
import { CustomSlider } from "./Common/CustomSlider";
import { NotificationManager } from "react-notifications";
import { ShimmerThumbnail } from "react-shimmer-effects";
import AdminChange from "../Assets/images/admin-change.svg";
import { EditProfileDialog } from "./Dialogues/EditProfileDialog";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ApiService from "../Services/ApiServices";
import { useHistory } from 'react-router-dom';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: "#cc5b02",
    color: "white",
    boxShadow: theme.shadows[1],
    fontSize: 10,
  },
  arrow: {
    color: "#cc5b02",
  },
}));

const DoctorDetails = () => {
  const classes = useStyles();
  const options = [
    {
      label: "Allow Remote Assessments",
      value: "assessment_link",
      tooltip:
        "Enables a link for users to access and complete the assessment online",
    },
    {
      label: "Allow Data Export",
      value: "export_data",
      tooltip:
        "Grants permission to generate and download assessment details as an Excel report",
    },
    {
      label: "Collect Symptoms",
      value: "symptoms",
      tooltip: "Gathers information on symptoms during the assessment process",
    },
    {
      label: "Collect Vitals",
      value: "vitals",
      tooltip: "Records vital signs during the assessment process",
    },
    {
      label: "Allow Feedback",
      value: "feedback",
      tooltip:
        "Provides an option for users to give feedback on the result screen",
    },
  ];

  const [loader, setLoader] = useState(false);
  const [response, setResponse] = useState();
  const [count, setCount] = useState();
  const [exportTypeOption, setExportType] = useState("");
  const [report, setReport] = useState("");
  const [radioData, setRadioData] = useState(
    options.reduce(
      (acc, option) => ({ ...acc, [option.value]: option.defaultChecked }),
      {}
    )
  );
  const [updatedImbricationsData, setUpdatedImbricationsData] = useState({});
  const [doctorName, setDoctorName] = useState("");
  const [salutation, setsalutation] = useState("");
  const [assessments, setAssessments] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [role, setRole] = useState("");
  const [risk, setRisk] = useState(0);
  const [pattern, setPattern] = useState(0);
  const [covid, setCovid] = useState(0);
  const [tb, setTb] = useState(0);
  const [patientsCount, setPatientsCount] = useState(0);
  const [assessmentsCount, setAssessmentsCount] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const [roles, setRoles] = useState(["Admin", "Doctor", "Health Worker"]);
  const [hoveredRole, setHoveredRole] = useState(null);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const apiService = new ApiService();

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  const handleOpenDeleteDialog = () => {
    setDeleteDialogOpen(true);
  };
  
  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
  };
  const params = useParams();
  const history = useHistory();
  const doctorID = params.loginId;

  useEffect(() => {
    getFetchConfigurations();
    getDoctorDetails();
    getAnalyticsForDoctor();
  }, []);

  const getFetchConfigurations = async () => {
    setLoader(true);
    try {
      const response = await axios.get(`/configurationData/${encodeURIComponent(doctorID)}`, {
        headers: { accessToken: localStorage.accessToken },
      });

      if (response.status === 200) {
        const config = response.data.configuration;
        setResponse(config);
        setRadioData({
          assessment_link: config.assessment_link,
          export_data: config.export_data,
          symptoms: config.symptoms,
          vitals: config.vitals,
          feedback: config.feedback,
        });
        setExportType(config.exportType);
        setReport(config.report_level);
        setCount(parseInt(config.assessment_limit) || 0);
        setRisk(config.risk_s);
        setPattern(config.pattern_s);
        setCovid(config.covid_s);
        setTb(config.tb_s);
      }
    } catch (error) {
      console.error("Error fetching configurations:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleDelete = async () => {
      try {
        const result = await apiService.deleteUser(doctorID);

        if (result.status === 'Success') {
          history.push('/doctorsList'); 
        } else {
          setErrorMessage('Failed to delete doctor');
        }
      } catch (error) {
        setErrorMessage('An error occurred while deleting the doctor');
    }
    setDeleteDialogOpen(false);
  };

  const getDoctorDetails = async () => {
    setLoader(true);
    await axios
      .get(`/getDoctors?userId=${encodeURIComponent(doctorID)}`, {
        headers: { accessToken: localStorage.accessToken },
      })
      .then((response) => {
        if (response.status === 200) {
          let fullName =
            response.data.data.users[0].firstname +
            " " +
            response.data.data.users[0].lastname;
          let response2 = response.data.data.users[0];
          if (response2.plan.includes("tb")) {
            localStorage.setItem("Tb", "tb");
           
          } else {
            localStorage.setItem("Tb", "null");
         
          }
          if (response2.plan.includes("covid")) {
            localStorage.setItem("plan", "covid");
           
          } else {
            localStorage.setItem("plan", "null");
          }
          setDoctorName(fullName);
          setsalutation(response2.salutation)
          setEmail(response2.email);
          setPhoneNumber(response2.contact);
          setAssessments(response2.total_assessments);
          setHospitalName(response2.hospitals);
          setRole(response2.role === 'health_worker' ? 'Health Worker' : response2.role);
          setLoader(false);

        }
      });
  };
  

  const getAnalyticsForDoctor = async () => {
    setLoader(true);
    try {
      const response = await axios.get(
        `getAnalyticsForDoctor?userId=${encodeURIComponent(doctorID)}`,
        {
          headers: { accessToken: localStorage.accessToken },
        }
      );

      if (response.status === 200) {
        setAssessmentsCount(response.data.total_assessment);
        setPatientsCount(response.data.total_patients);
      }
    } catch (error) {
      console.error("Error fetching analytics:", error);
    } finally {
      setLoader(false);
    }
  };

  const increaseAssessments = () => {
    setCount(count + 1);
  };

  const decreaseAssessments = () => {
    if (count <= 0) {
      setCount(0);
    } else setCount(count - 1);
  };
  const handleChange = (event) => {
    const value = event.target.value === "true";
    setRadioData({ ...radioData, [event.target.name]: value });
  };
  const handleImbricationsData = (response) => {
    setUpdatedImbricationsData(response);
  };

  const updateConfigurations = async () => {
    setLoader(true);
    var jsonData = {
      risk_s: risk,
      pattern_s: pattern,
      covid_s: covid,
      tb_s: tb,
      assessment_limit: count,
      assessment_link: radioData.assessment_link,
      exportType: exportTypeOption,
      export_data: radioData.export_data,
      feedback: radioData.feedback,
      report_level: report,
      symptoms: radioData.symptoms,
      vitals: radioData.vitals,
    };
    await axios
      .post(`/adminConfig?doctorId=${encodeURIComponent(doctorID)}`, jsonData, {
        headers: { accessToken: localStorage.accessToken },
      })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          NotificationManager.success(
            "Configurations Updated",
            "Success",
            5000
          );
          getFetchConfigurations();
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleRiskButton = (add, minus) => {
    if (add == true) {
      if (risk != 2) {
        setRisk(risk + 1);
      }
    }
    if (minus == true) {
      if (risk != 0) {
        setRisk(risk - 1);
      }
    }
  };
  const handleTbButton = (add, minus) => {
    if (add == true) {
      if (tb != 2) {
        setTb(tb + 1);
      }
    }
    if (minus == true) {
      if (tb != 0) {
        setTb(tb - 1);
      }
    }
  };
  const handlePatternButton = (add, minus) => {
    if (add == true) {
      if (pattern != 2) {
        setPattern(pattern + 1);
      }
    }
    if (minus == true) {
      if (pattern != 0) {
        setPattern(pattern - 1);
      }
    }
  };
  const handleCovidButton = (add, minus) => {
    if (add == true) {
      if (covid != 2) {
        setCovid(covid + 1);
      }
    }
    if (minus == true) {
      if (covid != 0) {
        setCovid(covid - 1);
      }
    }
  };
  const handleRiskChange = (event) => {
    setRisk(event.target.value);
  };
  const handleTbChange = (event) => {
    setTb(event.target.value);
  };
  const handlePatternChange = (event) => {
    setPattern(event.target.value);
  };
  const handleCovidChange = (event) => {
    setCovid(event.target.value);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleRoleChange = (newRole) => {
    setRole(newRole);
    setShowDropdown(false);

    if(newRole==='Admin'){
      newRole= 'admin'
    }else if(newRole==='Doctor'){
      newRole= 'doctor'
    }else if(newRole==='Health Worker'){
      newRole='health_worker'
    }
    
    const formData= new FormData()
    formData.append('docId', doctorID )
    formData.append('role', newRole)
    
     axios
    .post(`/updateDoctorParams`, formData, {
      headers: { accessToken: localStorage.accessToken },
    })
    .then((res) => {
      console.log(res);
      if (res.status === 200) {
        NotificationManager.success(
          "Role Updated",
          "Success",
          5000
        );
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
    });
  }

  
  const handleMouseEnter = (role) => {
    setHoveredRole(role);
  };

  const handleMouseLeave = () => {
    setHoveredRole(null);
  };

  return (
    <div className="admin-dashboard">
          <EditProfileDialog open={isDialogOpen} onClose={handleCloseDialog} />
      {loader ? (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              display: "flex",
              gap: "7px",
              justifyContent: "space-between",
            }}
          >
            <ShimmerThumbnail height={50} width={140} className="m-0" rounded />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "15px",
              }}
            >
              <ShimmerThumbnail
                height={50}
                width={150}
                className="m-0"
                rounded
              />
              <ShimmerThumbnail
                height={50}
                width={150}
                className="m-0"
                rounded
              />
            </div>
          </div>
          <div style={{ display: "flex", gap: "6px" }}>
            <ShimmerThumbnail
              height={620}
              width={330}
              className="m-0"
              rounded
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "7px",
                flexWrap: "wrap",
              }}
            >
              <ShimmerThumbnail
                height={310}
                width={480}
                className="m-0"
                rounded
              />
              <ShimmerThumbnail
                height={310}
                width={460}
                className="m-0"
                rounded
              />
              <ShimmerThumbnail
                height={300}
                width={950}
                className="m-0"
                rounded
              />
            </div>
            <div></div>
          </div>
        </div>
      ) : (
        <>
          <div className="admin-header">
            <h1 className="admin-heading">Client Admin</h1>
            <div className="admin-stats">
              <p className="admin-para">
                Our Patients{" "}
                <span style={{ fontSize: "14px", marginLeft: "10px" }}>
                  {patientsCount}
                </span>{" "}
              </p>
              <p className="admin-para">
                Assessments{" "}
                <span style={{ fontSize: "14px", marginLeft: "10px" }}>
                  {assessmentsCount}
                </span>
              </p>

           
            </div>
          </div>
          <div className="doctorDetails-and-configurations">
            <div className="doctor-details">
              <div className="d-d-card">
                <img className="profile-icon-img" src={profileIcon} alt="" />
                <div className="d-d-card2">
                  <p className="doctor-name">{salutation} {doctorName}</p>
                  <div
                    style={{
                      display: "flex",
                      gap: "6px",
                      alignItems: "center",
                    }}
                  >
                    <p className="details">{role}</p>
                    <img
                      src={AdminChange}
                      style={{
                        height: "20px",
                        width: "20px",
                        cursor: "pointer",
                      }}
                      onClick={toggleDropdown}
                      alt="change"
                    />
                  </div>
                  <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
                    <button className="edit-button" type="button" onClick={handleOpenDialog}
                        style={{
                          backgroundColor: '#FF8C00',
                          color: 'white',
                          padding: '5px 10px',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                        }}>
                      <EditIcon style={{ marginRight: '5px' }} />
                      Edit
                    </button>
                    <button className="delete-button" type="button" onClick={handleOpenDeleteDialog}
                        style={{
                          backgroundColor: '#FF8C00', 
                          color: 'white',
                          padding: '5px 10px',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                        }}>
                      <DeleteIcon style={{ marginRight: '5px' }} />
                      Delete
                    </button>
                          {/* Confirmation Dialog */}
                    <Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog}>
                      <DialogContent>
                        Are you sure you want to delete this doctor?
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleCloseDeleteDialog} color="primary">
                          Cancel
                        </Button>
                        <Button
                          onClick={handleDelete}
                          color="secondary"
                          style={{ backgroundColor: '#FF8C00', color: 'white' }}
                        >
                          Confirm
                        </Button>
                      </DialogActions>
                    </Dialog>
                        {/* Display error message if exists */}
                  {errorMessage && <div className="error-message">{errorMessage}</div>}
                  </div>
                  {showDropdown && (
                    <div
                      className="dropdown"
                      style={{
                        position: "absolute",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                      }}
                    >
                      {roles.map((r) => (
                        <p
                          key={r}
                          onClick={() => handleRoleChange(r)}
                          onMouseEnter={() => handleMouseEnter(r)}
                          onMouseLeave={handleMouseLeave}
                          className="edit-option"
                          style={{
                            backgroundColor:r === role? "orange": r === hoveredRole? "orange": "white",
                            color:
                              r === role
                                ? "white"
                                : r === hoveredRole
                                ? "white"
                                : "black",
                          }}
                        >
                          {r}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div class="line-2"></div>
              <div className="user-info-card">
                <div className="user-info">
                  <h1 className="doctor-name">User Info</h1>
                  {/* <div className="change-container">
                    <p className="change">Change</p>
                    <div class="rectangle-1875">
                      <img src={changeIcon} alt="" />
                    </div>
                  </div> */}
                </div>
                <div className="doctor-details-card">
                  <div className="d-d-sub">
                    <p className="hospital">Hospital</p>
                    <p className="hospital-d">{hospitalName}</p>
                  </div>
                  <p className="hospital">Contact</p>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <img src={emailIcon} alt="" />{" "}
                    <p className="hospital-d"> &nbsp; {email}</p>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <img src={phoneIcon} alt="" />{" "}
                    <p className="hospital-d"> &nbsp; {phoneNumber}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="usage-configurations">
              <div className="uc-header">
                <h1 className="uc-heading">Usage Configurations</h1>
                <></>
                {/* <button className="uc-apply" onClick={updateConfigurations}>
                  Apply Configuration
                </button> */}
              </div>
              <div className="v-line"></div>
              <div className="uc-top">
                <div className="radio-buttons-container2">
                  {options.map((option) => (
                    <div key={option.value} className="radio-button-container2">
                      <div style={{ width: "250px", height: "36px" }}>
                        <span className="radio-para">{option.label}</span>
                        <Tooltip
                          title={option.tooltip}
                          classes={{
                            tooltip: classes.tooltip,
                            arrow: classes.arrow,
                          }}
                          arrow
                        >
                          <img
                            src={Info}
                            className="info-icon-configuration"
                            alt="info"
                          />
                        </Tooltip>
                      </div>

                      <div className="radio-input-container">
                        <input
                          className="custom-radio"
                          type="radio"
                          name={option.value}
                          value="true"
                          checked={radioData[option.value]}
                          onChange={handleChange}
                          disabled
                          style={{ cursor: "not-allowed" }}
                        />
                        <label className="radio-label">Yes</label>
                      </div>
                      <div className="radio-input-container">
                        <input
                          type="radio"
                          className="custom-radio"
                          name={option.value}
                          value="false"
                          checked={!radioData[option.value]}
                          onChange={handleChange}
                          disabled
                          style={{ cursor: "not-allowed" }}
                        />
                        <label className="radio-label">No</label>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="vertical-line-configuration"></div>
                <div className="select-options-container">
                  {radioData?.assessment_link ? (
                    <div className="select-button-container2">
                      <p className="select-para2">Assessments Count</p>
                      <div className="assessments-count-container2">
                        <p
                          style={{ color: "#FF7D00", cursor: "not-allowed" }}
                          // onClick={decreaseAssessments}
                          disabled={!radioData?.assessment_link}
                        >
                          -
                        </p>
                        <input
                          type="num"
                          className="assessment-count-select2"
                          value={
                            count === null ? 0 : count < 10 ? count : count
                          }
                        />
                        <p
                          style={{ color: "#FF7D00", cursor: "not-allowed" }}
                          // onClick={increaseAssessments}
                          disabled={!radioData?.assessment_link}
                        >
                          +
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="select-button-container2 disabled">
                      <p className="select-para2">Assessments Count</p>
                      <div className="assessments-count-container2">
                        <input
                          type="num"
                          className="assessment-count-select2"
                          // style={{ marginLeft: "100px", backgroundColor: "white" }}
                          disabled
                          value="00"
                          style={{ cursor: "not-allowed" }}
                        />
                      </div>
                    </div>
                  )}
                  <div className="select-button-container2">
                    <label htmlFor="exportTypeOptions" className="select-para2">
                      Export Type
                    </label>
                    <select
                      id="exportTypeOptions"
                      className="assessments-count-container2"
                      value={exportTypeOption}
                      onChange={(e) => setExportType(e.target.value)}
                      disabled
                      style={{ cursor: "not-allowed" }}
                    >
                      <option value="apollo">Apollo</option>
                      <option value="full">Full</option>
                      <option value="basic">Basic</option>
                    </select>
                  </div>
                  <div className="select-button-container2">
                    <label htmlFor="reportOptions" className="select-para2">
                      Report
                    </label>
                    <select
                      id="reportOptions"
                      className="assessments-count-container2"
                      value={report}
                      onChange={(e) => setReport(e.target.value)}
                      disabled
                      style={{ cursor: "not-allowed" }}
                    >
                      <option value="basic">Basic</option>
                      <option value="old_default">Default</option>
                      <option value="summary">Summary</option>
                      <option value="detailed">Detailed</option>
                      <option value="advanced">Advanced</option>
                      <option value="advReport">AdvReport</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="v-line"></div>
              <div className="imbrications-container">
                <CustomSlider
                  prefix="Risk"
                  heading="Sensitivity"
                  value={risk}
                  disabled={true}
                  // handleChange={handleRiskChange}
                  // handleButton={handleRiskButton}
                />
                <CustomSlider
                  prefix="Pattern"
                  heading="Sensitivity"
                  value={pattern}
                  disabled={true}
                  // handleChange={handlePatternChange}
                  // handleButton={handlePatternButton}
                />
                {localStorage.plan ==='covid' && 
                <CustomSlider
                  prefix="Covid"
                  heading="Sensitivity"
                  value={covid}
                  disabled={true}
                  // handleChange={handleCovidChange}
                  // handleButton={handleCovidButton}
                />
                }
                {localStorage.Tb==='tb' && <CustomSlider
                  prefix="TB"
                  heading="Sensitivity"
                  value={tb}
                  disabled={true}
                  // handleChange={handleTbChange}
                  // handleButton={handleTbButton}
                />
                }
                
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DoctorDetails;